<template>
  <div class="hsec">
    <div class="row top">
      <div class="col header-text">
        <div class="pre-header">{{ $t('views.affiliate.affiliateProgram') }}</div>
        <h1>{{ $t('views.affiliate.becomeAnIncome') }}<span class="blue">{{ $t('views.affiliate.affiliate') }}</span></h1>
        <h3>{{ $t('views.affiliate.referInvestorsTo') }}</h3>
        <div>
          <b-button class="join" href="https://getincome.targetcircle.com/signup">{{ $t('views.affiliate.joinOurAffiliateProgram') }}</b-button>
        </div>
      </div>
      <div class="col top-block">
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="top-title">{{ $t('views.affiliate.whatCanWe') }}</div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="risk-box">
                    <div class="title">{{ $t('views.affiliate.earnAGreat') }}</div>
                    <div class="desc">
                      <p>{{ $t('views.affiliate.asAnAffiliate') }}</p>
                      <p>{{ $t('views.affiliate.youEarn') }}</p>
                      <p>{{ $t('views.affiliate.youEarn1') }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="risk-box">
                    <div class="title">{{ $t('views.affiliate.everydaySupport_Content') }}</div>
                    <div class="desc"><p>{{ $t('views.affiliate.weAreCommitted') }}</p>
                      <p>{{ $t('views.affiliate.prioritySupportVia') }}</p>
                      <p>{{ $t('views.affiliate.weProvideA') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <hr/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="row hdit">
            <div class="title">{{ $t('views.affiliate.howDoesItWork') }}</div>
            <div class="header">{{ $t('views.affiliate.getStarted') }}</div>
            <div>{{ $t('views.affiliate.getYourAudience') }}</div>
            <div class="header">{{ $t('views.affiliate.nextSteps') }}</div>
            <div>{{ $t('views.affiliate.forOurAffiliate') }}</div>
            <div class="header">{{ $t('views.affiliate.startPromoting') }}</div>
            <div>{{ $t('views.affiliate.theDetailsOf') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="equal-opportunity">
            <div class="row">
              <div class="col-12 col-md-5 col-lg-5 col-xl-5"></div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6 text">
                <div class="head">{{ $t('views.affiliate.becomeOurAffiliate') }}<br/><span class="blue">{{ $t('views.affiliate.today') }}</span>
                  <div class="footer-register">
<!--                    <b-button class="join" to="/register">{{ $t('views.affiliate.joinOurAffiliateProgram1') }}</b-button>-->
                    <b-button class="join" href="https://getincome.targetcircle.com/signup">{{ $t('views.affiliate.joinOurAffiliateProgram2') }}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Affiliate'
}
</script>

<style scoped lang="scss">

.hsec {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.header-text {
  text-align: center;
  margin: 82px auto 16px 10%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url("../assets/forest.png");
  background-position: left 0;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;
  background-size: contain;

  .text {
    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 50px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      /*margin: 85px 16px;*/
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
    }
  }
}

.top-block {
  background-image: url("../assets/balloons.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.black-box {
  background: #000000;
  margin: 24px 0;
  padding: 25px;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: #FFFFFF;
    margin-bottom: 10px;
    text-align: center;
  }

  .desc {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
  }
}

.risk-box {
  margin: 5px;
  padding: 5px;

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: #000000;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin: 36px 0;
    border-bottom: 1px solid #6E777A;
  }

  .desc {
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
  }
}

.info-img {
  text-align: center;
  width: 100%;

  img {
    max-width: 100px;
  }
}

.footer-register {
  margin-top: 20px;
  margin-bottom: 20px;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .top-block {
    display: none;
  }
  .equal-opportunity {
    background-size: cover;

    .head {
      margin: 30px 16px !important;
    }
  }
}

@media only screen and (max-width: 764px) {
  .equal-opportunity {
    .head {
      margin: 85px 16px;
    }
  }
}

@media only screen and (max-width: 1024px) {

  .equal-opportunity {
    .text {
      margin: 10px
    }
  }
}

.top-title {
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 60px;
  width: 100%;
}

.hdit {
  margin: 36px 0;

  div {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
    text-align: justify;
  }

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 24px;
    width: 100%;
    margin-bottom: 10px;
    color: black;
  }

  .header {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    color: black;
    margin-top: 15px;
  }
}

.join {
  background: #30A7FE;
  border-radius: 10px;
  color: white;
  border: none;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 34px;
}

[lang="de"] {
  .risk-box {
    @media screen and (min-width: 991px) {
      .title {
        min-height: 60px;
        align-items: self-start !important;
      }
    }
  }
}
</style>
